import type { ReactNode } from 'react';

export const symbol_crop_2_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M300-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h360q24 0 42 18t18 42v680q0 24-18 42t-42 18H300Zm0-60h360v-680H300v680Zm0 0v-680 680Z"
		/>
	</svg>
);
